import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import {Container} from './styles';
import { toast, Slide, ToastContainer } from 'react-toastify';
import '../../css/ReactToastify.css';
import { IoMdCloseCircle, IoMdCheckmarkCircle } from 'react-icons/io'
import Dollar from '../../assets/emojis/dollar/dollar@3x.png'

import Visa from '../../assets/pagamentos/cartoes/visa/visa@3x.png';
import Cabal from '../../assets/pagamentos/cartoes/cabal/cabal@3x.png';
import MasterCard from '../../assets/pagamentos/cartoes/mastercard/mastercard@3x.png';
import Elo from '../../assets/pagamentos/cartoes/elo/elo@3x.png';
import Amex from '../../assets/pagamentos/cartoes/amex/amex@3x.png';
import Diners from '../../assets/pagamentos/cartoes/diners/diners@3x.png';
// import Hiper from '../../assets/pagamentos/cartoes/hiper/hiper@3x.png';
import HiperCard from '../../assets/pagamentos/cartoes/hipercard/hipercard@3x.png';
import VR from '../../assets/pagamentos/vales/vr/vr@3x.png';
import Sodexo from '../../assets/pagamentos/vales/sodexo/sodexo@3x.png';
import Ticket from '../../assets/pagamentos/vales/ticket/ticket-refeicao@3x.png';
import Verocard from '../../assets/pagamentos/vales/verocard/verocard@3x.png';
import Coopercred from '../../assets/pagamentos/vales/coopercard/coopercard@3x.png';
import Ben from '../../assets/pagamentos/vales/ben/ben@3x.png';
import Banri from '../../assets/pagamentos/vales/banri/banri@3x.png';
import Sincard from '../../assets/pagamentos/vales/sincard/sincard@3x.png';
import Alelo from '../../assets/pagamentos/vales/alelo/alelo@3x.png';
import Pix from '../../assets/pagamentos/flag_pix.svg';

export default class FormasDePagamento extends Component {
    constructor(props) {
        super(props);
        this.state = {
            app: [
                {
                    nome: 'Visa',
                    id: 1
                },
                {
                    nome: 'MasterCard',
                    id: 2
                },
                {
                    nome: 'Elo',
                    id: 3
                },
                {
                    nome: 'American Express',
                    id: 4
                },
                {
                    nome: 'Diners',
                    id: 5
                }
            ],
            credito: [],
            debito: [],
            vale: [],
            idArrayInicial: [],
            idArrayFinal: [],
            superUser: false,
            permission: null,
            showButton: false,
            carregou: false,
            token: null,
            saved: false
        }
    }

    success = () => {
        toast.dismiss();
        const ToastSuccess = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCheckmarkCircle color="#51db74" size={28}/>
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#5b8e3e",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>As alterações foram salvas com sucesso.</span>
                </div>
            </div>
        );
        toast.success(<ToastSuccess />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide,
        });
    }
    error = () => {
        toast.dismiss();
        const ToastError = () => (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'center'
            }}>
                <div>
                    <IoMdCloseCircle color="#d2252e" size={28}/>
                </div>
                <div style={{ paddingLeft: 16 }}>
                    <span style={{
                        fontFamily: 'Montserrat',
                        color: "#983236",
                        fontSize: 16,
                        textAlign: 'center'
                    }}>Ocorreu um erro. Tente novamente mais tarde.</span>
                </div>
            </div>
        );
        toast.error(<ToastError />, {
            position: toast.POSITION.BOTTOM_CENTER,
            hideProgressBar: true,
            autoClose: 8000,
            closeButton: false,
            pauseOnHover: false,
            transition: Slide
        });
    }

    async componentDidMount() {
        toast.configure();
        const token = await localStorage.getItem('@jwt');
        const isSuser = await localStorage.getItem('@internal');
        this.setState({ token: token });
        if(isSuser) {
            const permissions = await JSON.parse(localStorage.getItem('@suser'))
            this.setState({superUser: true, permission: permissions.configuracoes});
        }
        if(this.state.superUser) {
            if(this.state.permission !== 0) {
                await this.getFormas();
            }
        } else {
            await this.getFormas();
        }
    }

    async getFormas() {
        try {
            api.post('api/restauranteconfigs/listaPagamentos',{},{
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            }).then(async res => {
                const tipos = res.data.formas;
                let { credito, debito, vale } = tipos[0];
                let { restformas } = tipos[1];
                let idArray = [];
                let idArray2 = [];
                for (let i = 0; i < credito.length; i++) {
                    credito[i].check = false;
                    for (let j = 0; j < restformas.length; j++) {
                        if (credito[i].id === restformas[j].tipo_pagamento_id) {
                            credito[i].check = true;
                            idArray.push(credito[i].id)
                            idArray2.push(credito[i].id)
                        }
                    }
                }
                for (let i = 0; i < debito.length; i++) {
                    debito[i].check = false;
                    for (let j = 0; j < restformas.length; j++) {
                        if (debito[i].id === restformas[j].tipo_pagamento_id) {
                            debito[i].check = true;
                            idArray.push(debito[i].id)
                            idArray2.push(debito[i].id)
                        }
                    }
                }
                for (let i = 0; i < vale.length; i++) {
                    vale[i].check = false;
                    for (let j = 0; j < restformas.length; j++) {
                        if (vale[i].id === restformas[j].tipo_pagamento_id) {
                            vale[i].check = true;
                            idArray.push(vale[i].id)
                            idArray2.push(vale[i].id)
                        }
                    }
                }
                this.setState({
                    credito: credito,
                    debito: debito,
                    vale: vale,
                    idArrayInicial: idArray,
                    idArrayFinal: idArray2,
                    carregou: true
                });    
            }).catch(async e => {
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                        await localStorage.removeItem('@jwt');
                        await localStorage.removeItem('@user');
                        await localStorage.removeItem('@rest');
                        await localStorage.removeItem('@internal');
                        await localStorage.removeItem('@uf');
                        await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            });
        } catch (e) {
            console.log(e.data);
        }
    }

    handleChange(id, check, event) {
            let credit = this.state.credito;
            let debit = this.state.debito;
            let ticket = this.state.vale;
            let ids = this.state.idArrayFinal;
            switch (event.target.name) {
                case 'credito':
                    for (let i = 0; i < credit.length; i++) {
                        if (credit[i].id === id) {
                            credit[i].check = !check;
                        }
                    }
                    if (check === false) {
                        ids.push(id);
                    } else {
                        let index = ids.indexOf(id);
                        ids.splice(index, 1)
                    }
                    break;
                case 'debito':
                    for (let i = 0; i < debit.length; i++) {
                        if (debit[i].id === id) {
                            debit[i].check = !check;
                        }
                    }
                    if (check === false) {
                        ids.push(id);
                    } else {
                        let index = ids.indexOf(id);
                        ids.splice(index, 1)
                    }
                    break;
                case 'vale':
                    for (let i = 0; i < ticket.length; i++) {
                        if (ticket[i].id === id) {
                            ticket[i].check = !check;
                        }
                    }
                    if (check === false) {
                        ids.push(id);
                    } else {
                        let index = ids.indexOf(id);
                        ids.splice(index, 1)
                    }
                    break;
                default:
                    break;
            }
            this.verificarBotao()
    }

    async salvar() {
        try {
            api.post('api/restauranteconfigs/attpagamentos', {
                        formas: this.state.idArrayFinal
                    },{
                        headers: {
                            Authorization: `Bearer ${this.state.token}`
                        }
                    }).then(async res => {
                        this.success();
                        this.setState({ 
                            saved: false,
                         });
                         this.getFormas();
                    }).catch(async e => {
                        this.error();
                        if (e.response.status === 401) {
                            try {
                                await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@suser');
                                this.setState({
                                    redirect: true
                                })
                            } catch (e) {
                                console.log(e.data);
                            }
                        }
                    });
                    
        } catch (error) {
            console.log(error.data);
        }
    }

    verificarBotao() {
        let respostas = [];
        if (this.state.idArrayInicial.length === this.state.idArrayFinal.length) {
            for (let i = 0; i < this.state.idArrayInicial.length; i++) {
                const index = this.state.idArrayFinal.indexOf(this.state.idArrayInicial[i]);
                if (index === -1) {
                    respostas.push(index)
                }
            }
            if (respostas.length !== 0) {
                this.setState({
                    showButton: true
                })
            } else {
                this.setState({
                    showButton: false
                })
            }

        } else {
            this.setState({
                showButton: true
            })
        }
        this.setState({
            saved: true
        })
    }

    render() {
        return(
            this.state.superUser && this.state.permission === 0 ? (
                <Container>
                    <h1 style={{
                        fontFamily: 'Montserrat',
                        fontSize: 18,
                        fontWeight: 600
                    }}>Você não possui permissão para visualizar esta página.</h1>
                </Container>
            ) : (
            <Container>
                <ToastContainer limit={1} />
            
            {this.state.carregou ?
            <div className="div-pai">
                <div className="div-rota">

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/'}>
                    <span
                        className="rotas" >
                        Início
                    </span>
                </Link>
                
                <span className="rotas"> {'>'} </span>
                
                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/configuracoes'}>
                    <span
                        className="rotas">
                        Configurações
                    </span>
                </Link>

                <span className="rotas"> {'>'} </span>

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/configuracoes/formas-de-pagamento'}>
                    <span>
                        Formas de pagamento
                    </span>
                </Link>

                </div>

                <img alt="" className="emoji" src={Dollar} />

                <h1>Formas de pagamento</h1>

                <h5>Escolha as formas de pagamento que os seus clientes vão usar.</h5>

                <hr/>

                <div className="div-app">
                    <h2>Pagamento pelo aplicativo</h2>
                        <h4>Crédito</h4>
                        
                    <div className="cards">
                            {this.state.app.map(item => (
                                        <div
                                            className="cartao" 
                                            key={item.id}>
                                            <label className="main">
                                                <input
                                                    type="checkbox" 
                                                    name={item.nome} 
                                                    id={item.id}
                                                    defaultChecked={true}
                                                    disabled={true}
                                                />
                                                <span className="check-app"></span> 
                                                <img alt="" src={
                                                    item.nome === 'Visa' ? Visa : item.nome === 'MasterCard' ? MasterCard :
                                                    item.nome === 'Elo' ? Elo : item.nome === 'American Express' ? Amex :
                                                    item.nome === 'Diners' ? Diners : null
                                                } 
                                                className="img-app-disabled"/>
                                                <span className="label-app">{item.nome}</span>
                                            </label>
                                        </div>
                                    ))}
                        </div>
                            
                </div>

                <hr className="linha"/>
                
                <div className="div-entrega">
                    <h2>Pagamento na entrega</h2>

                    <h4>Crédito</h4>

                    <div className="cards">
                                {this.state.credito.map(item => (
                                    <div
                                        className="cartao" 
                                        key={item.id}>
                                        <label className="main">
                                            <input
                                                disabled={
                                                    this.state.superUser ? 
                                    this.state.permission === 2 ? false : true 
                                    : false
                                                }
                                                type="checkbox" 
                                                name="credito" 
                                                id={item.id}
                                                defaultChecked={item.check}
                                                onChange={(event) => 
                                                    this.handleChange(item.id, item.check, event)
                                                }
                                            />
                                            <span className={
                                                this.state.superUser ? 
                                                this.state.permission === 2 ? "check" : "check-app" 
                                                : "check"
                                            }></span> 
                                            <img alt="" src={
                                                    item.nome === 'Visa (Crédito)' ? Visa : item.nome === 'MasterCard (Crédito)' ? MasterCard :
                                                    item.nome === 'Elo (Crédito)' ? Elo : item.nome === 'American Express (Crédito)' ? Amex :
                                                    item.nome === 'Diners' ? Diners : item.nome === 'Hipercard' ? HiperCard :
                                                    item.nome === 'Cabal (Crédito)' ? Cabal : null
                                                } 
                                                className={ 
                                                    this.state.superUser ? 
                                    this.state.permission === 2 ? null : "img-app-disabled" 
                                    : null
                                                } />
                                            <span className={
                                                this.state.superUser ? 
                                    this.state.permission === 2 ? "label-resto" : "label-app" 
                                    : "label-resto"
                                            }>{
                                                item.nome === 'Visa (Crédito)' ? 'Visa' : item.nome === 'MasterCard (Crédito)' ? 'MasterCard' :
                                                item.nome === 'Elo (Crédito)' ? 'Elo' : item.nome === 'American Express (Crédito)' ? 'American Express' :
                                                item.nome === 'Diners' ? 'Diners' : item.nome === 'Hipercard' ? 'HiperCard' :
                                                item.nome === 'Cabal (Crédito)' ? 'Cabal' : null
                                            }</span>
                                         </label>
                                    </div>
                                ))}
                        </div>

                    <h4>Débito</h4>

                    <div className="cards">
                                {this.state.debito.map(item => (
                                    <div 
                                        className="cartao"
                                        key={item.id}>
                                        <label className="main">
                                            <input
                                                disabled={
                                                    this.state.superUser ? 
                                    this.state.permission === 2 ? false : true 
                                    : false
                                                }
                                                type="checkbox" 
                                                name="debito"
                                                id={item.id}
                                                defaultChecked={item.check}
                                                onChange={(event) => 
                                                    this.handleChange(item.id, item.check, event)
                                                }
                                            />
                                            <span className={
                                                this.state.superUser ? 
                                                this.state.permission === 2 ? "check" : "check-app"
                                                : "check"
                                            }></span> 
                                            <img alt="" src={
                                                    item.nome === 'Visa (Débito)' ? Visa : item.nome === 'MasterCard (Débito)' ? MasterCard :
                                                    item.nome === 'Diners' ? Diners :
                                                    item.nome === 'Elo (Débito)' ? Elo : item.nome === 'American Express (Débito)' ? Amex :
                                                    item.nome === 'Cabal (Débito)' ? Cabal : item.nome === 'Pix ou Dinheiro (Confirmar com o cliente)' ? Pix : null
                                                } 
                                                className={ 
                                                    this.state.superUser ? 
                                    this.state.permission === 2 ? null : "img-app-disabled" 
                                    : null
                                                    } />
                                            <span className={
                                                this.state.superUser ? 
                                    this.state.permission === 2 ? "label-resto" : "label-app" 
                                    : "label-resto"
                                            }>{
                                                item.nome === 'Visa (Débito)' ? 'Visa' : item.nome === 'MasterCard (Débito)' ? 'MasterCard' :
                                                item.nome === 'Diners' ? 'Diners' :
                                                item.nome === 'Elo (Débito)' ? 'Elo' : item.nome === 'American Express (Débito)' ? 'American Express' :
                                                item.nome === 'Cabal (Débito)' ? 'Cabal' : item.nome === 'Pix ou Dinheiro (Confirmar com o cliente)' ? 'Pix' : null
                                            }</span>    
                                        </label>
                                    </div>
                                ))}
                        </div>

                    <h4>Vale-refeição</h4>

                    <div className="cards">
                            {this.state.vale.map(item => (
                                    <div
                                        className="cartao" 
                                        key={item.id}>
                                        <label className="main">
                                            <input
                                                disabled={
                                                    this.state.superUser ? 
                                    this.state.permission === 2 ? false : true 
                                    : false
                                                }
                                                type="checkbox" 
                                                name="vale" 
                                                id={item.id}
                                                defaultChecked={item.check}
                                                onChange={(event) => 
                                                    this.handleChange(item.id, item.check, event)
                                                }
                                            />
                                            <span className={
                                                this.state.superUser ? 
                                    this.state.permission === 2 ? "check" : "check-app" 
                                    : "check"
                                                }></span> 
                                            <img alt="" src={
                                                    item.nome === 'Alelo Refeição' ? Alelo : item.nome === 'Verocard Alimentação' ? Verocard :
                                                    item.nome === 'Sodexo' ? Sodexo : item.nome === 'Ticket Refeição' ? Ticket :
                                                    item.nome === 'Coopercred' ? Coopercred : item.nome === 'Alelo Alimentação' ? Alelo :
                                                    item.nome === 'VR Refeição' ? VR : item.nome === 'Banri Compras' ? Banri :
                                                    item.nome === 'Sodexo Refeição' ? Sodexo : item.nome === 'Ben Alimentação' ? Ben :
                                                    item.nome === 'Ben Refeição' ? Ben : item.nome === 'Sincard' ? Sincard : 
                                                    null
                                                } 
                                                className={
                                                     this.state.superUser ? 
                                    this.state.permission === 2 ? null : "img-app-disabled" 
                                    : null
                                                     } />
                                            <span className={
                                                this.state.superUser ? 
                                    this.state.permission === 2 ? "label-resto" : "label-app" 
                                    : "label-resto"
                                                }>{item.nome}</span>    
                                        </label>
                                    </div>
                                ))}                                
                        </div>

                </div>

                {
                    this.state.showButton ? 
                    this.state.superUser ?
                        this.state.permission === 2 ?
                        this.state.saved && (
                            <div className="botao">
                            <button
                                onClick={() => this.salvar()} 
                                className="salvar">
                                Salvar alterações
                            </button>
                            </div>
                        )
                        : null
                    :   
                    this.state.saved && (
                        <div className="botao">
                                <button
                                    onClick={() => this.salvar()} 
                                    className="salvar">
                                    Salvar alterações
                                </button>
                            </div>
                    )
                    : null
                }

            </div>
            : null}
            </Container> )
        )
    }
}
